import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import type { UsePlatformRouteWeb } from './types';

export const usePlatformRoute = (): UsePlatformRouteWeb => {
    const router = useRouter();
    return router;
};
